import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultSiteMetadata = {
  title: '',
  url: ''
};
export var SiteMetadataContext = React.createContext(defaultSiteMetadata);
export var SiteMetadataProvider = createInheritedProvider(SiteMetadataContext);